import React from 'react';
import './WelcomeDiscountModal.css';

interface WelcomeDiscountModalProps {
    isOpen: boolean;
    onClose: () => void;
    discountCode: string;
    discountPercentage: number;
}

const WelcomeDiscountModal: React.FC<WelcomeDiscountModalProps> = ({
    isOpen,
    onClose,
    discountCode,
    discountPercentage
}) => {
    if (!isOpen) return null;

    return (
        <div className="welcome-discount-overlay" onClick={onClose}>
            <div className="welcome-discount-modal" onClick={onClose}>


                <div className="welcome-discount-icon">
                    🌼 🌿
                </div>

                <h2 className="welcome-discount-title">
                    Spring is Here!
                </h2>

                <p className="welcome-discount-message">
                    <strong>{discountCode}</strong> discount automatically applied with <strong>{discountPercentage}% off</strong> your order!
                </p>

                <p className="welcome-discount-message">
                    🚚 Free delivery in Cambourne!
                </p>

                <button className="welcome-discount-button" onClick={onClose}>
                    Browse the Menu
                </button>
            </div>
        </div>
    );
};

export default WelcomeDiscountModal;
